"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSiteInfoService = void 0;
var React = require("react");
var immer_1 = require("immer");
var RestData_1 = require("../rest/RestData");
var urls_1 = require("../urls");
var initial_data = {
    id: undefined,
    project_id: undefined,
    address: undefined,
    postcode: undefined,
};
var SiteInfoAction;
(function (SiteInfoAction) {
    SiteInfoAction["CHANGE_DATA"] = "CHANGE_DATA";
})(SiteInfoAction || (SiteInfoAction = {}));
function site_data_reducer(state, action) {
    if (action.type == RestData_1.DataActionType.LIST_POST) {
        return action.payload;
    }
    if (action.type == RestData_1.DataActionType.UPDATE_POST) {
        return action.payload;
    }
    if (action.type == SiteInfoAction.CHANGE_DATA) {
        return (0, immer_1.default)(state, function (draft) {
            draft[action.name] = action.value;
        });
    }
    return state;
}
function useSiteInfoService(project_id) {
    var _a = __read(React.useReducer(site_data_reducer, initial_data), 2), site_data = _a[0], dispatch = _a[1];
    var rest_svc = (0, RestData_1.useRestData)((0, urls_1.resolve)(urls_1.Urls.admin_sites, project_id), dispatch);
    function change_data(name, value) {
        dispatch({
            type: SiteInfoAction.CHANGE_DATA,
            payload: undefined,
            name: name,
            value: value,
        });
    }
    return [
        site_data,
        {
            list: rest_svc.list,
            update: rest_svc.update,
            change_data: change_data,
        },
    ];
}
exports.useSiteInfoService = useSiteInfoService;
